export default __webpack_public_path__ + "static/media/check.c521c493.png";